import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import BookingPage from "./features/bookings/BookingPage";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./config/store";
import Dashboard from "./pages/yavolaDashboard/index";
import ManageBookings from "./features/dashboard/ManageBookings/index";
import ManageCars from "./features/dashboard/ManageCars/ManageCars";
import Login from "./features/dashboard/Login/index";
import ProtectedRoute from "./features/dashboard/Login/ProtectedRoute";
import PaymentSuccess from "./features/bookings/payment/PaymentSuccess";

// import your other page components

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Routes>
            <Route path="/" element={<BookingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/dashboard" element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />}>
                <Route path="ManageBookings" element={<ManageBookings />} />
                <Route path="ManageCars" element={<ManageCars />} />
              </Route>
            </Route>
          </Routes>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
